import InterviewContextProvider from "./InterviewContext";
import InterviewHeader from "./InterviewHeader";
import InterviewPage from "./Interviewpage";
import PropTypes from "prop-types";

const NewInterview = ({ match }) => {
  return (
    <InterviewContextProvider>
      <InterviewHeader />
      <InterviewPage interviewId={match.params.id} />
    </InterviewContextProvider>
  );
};

export default NewInterview;

NewInterview.propTypes = {
  match: PropTypes.object.isRequired
};
